:where(button, a) {
  all: unset;
  display: inline-flex;
  align-items: center;
  user-select: none;
  touch-action: manipulation;
  cursor: pointer;
}

button:disabled {
  pointer-events: none;
}

*,
::after,
::before {
  box-sizing: border-box;
}

:host {
  display: grid;
  position: relative;
}

:host(.expandable) {
  grid-template-rows: max-content 0fr;
  transition: grid-template-rows var(--ch-navigation-list-item-expand-collapse-duration) var(--ch-navigation-list-item-expand-collapse-timing-function);
}

:host(.expandable--expanded) {
  grid-template-rows: max-content 1fr;
}

.indicator {
  position: absolute;
  inset-block: 0;
  inset-inline-start: 0;
  inline-size: 2px;
  background-color: currentColor;
  pointer-events: none;
}

.ch-disabled {
  pointer-events: none;
}

.caption {
  display: flex;
  align-items: center;
  flex: 1;
}

.expandable {
  display: grid;
  overflow: hidden;
  transition: visibility var(--ch-navigation-list-item-expand-collapse-duration) allow-discrete;
}
.expandable--collapsed {
  visibility: hidden;
}

.expandable-button::before {
  content: "";
  display: grid;
  place-items: center;
  inline-size: var(--ch-navigation-list-item__expandable-button-size);
  block-size: var(--ch-navigation-list-item__expandable-button-size);
  pointer-events: none;
  order: -2;
  z-index: 1;
  background-color: currentColor;
  -webkit-mask: no-repeat center/var(--ch-navigation-list-item__expandable-button-image-size) url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none"><path d="M16.5 5L8.7 12.7L1 5" stroke="%23000" stroke-width="1.2" stroke-linecap="round"/></svg>');
  transition: transform var(--ch-navigation-list-item-expand-collapse-duration) var(--ch-navigation-list-item-expand-collapse-timing-function);
}
.expandable-button--end::before {
  order: 1;
}
.expandable-button--collapsed-start::before {
  transform: rotate(-90deg);
}
.expandable-button--expanded-end::before {
  transform: rotate(-180deg);
}

.action {
  display: flex;
  align-items: center;
  gap: var(--ch-navigation-list-item-gap);
  padding-inline-start: var(--ch-navigation-list-item-indentation);
  --ch-navigation-list-item-start-img: var(--ch-start-img--base);
}
.action--navigation-list-collapsed {
  flex-direction: column;
  text-align: center;
}
.action.start-img--hover:hover {
  --ch-navigation-list-item-start-img: var(--ch-start-img--hover);
}
.action.start-img--active:active {
  --ch-navigation-list-item-start-img: var(--ch-start-img--active);
}
.action.start-img--focus:focus {
  --ch-navigation-list-item-start-img: var(--ch-start-img--focus);
}
.action.start-img--disabled.ch-disabled {
  --ch-navigation-list-item-start-img: var(--ch-start-img--disabled);
}

.pseudo-img--start::after {
  order: -1;
  content: "";
  display: block;
  inline-size: var(--ch-navigation-list-item__image-size);
  block-size: var(--ch-navigation-list-item__image-size);
  content-visibility: auto;
  contain-intrinsic-size: auto var(--ch-navigation-list-item__image-size);
}

.start-img-type--background::after {
  background: no-repeat center/var(--ch-navigation-list-item__background-image-size) var(--ch-navigation-list-item-start-img);
}

.start-img-type--mask::after {
  -webkit-mask: no-repeat center/var(--ch-navigation-list-item__background-image-size) var(--ch-navigation-list-item-start-img);
  background-color: currentColor;
}

ch-tooltip {
  --ch-tooltip-separation: var(--ch-navigation-list-item__tooltip-separation);
  --ch-tooltip-separation-x: var(
    --ch-navigation-list-item__tooltip-separation-x
  );
  --ch-tooltip-separation-y: var(
    --ch-navigation-list-item__tooltip-separation-y
  );
}